import { getFontFamily } from 'src/app/project/modules/white-label/white-label-utils/get-font-family';
import { TDashletGraphOptions } from '../../dashlet-graph.model';

const fontColor = '#586378';

export function generateDoughnutGraphOptions(
  isMobile: boolean,
  isExport: boolean,
): TDashletGraphOptions {
  const fontSize = isExport ? 42 : 12;
  const fontFamily = getFontFamily();
  if (!isMobile) {
    return {
      devicePixelRatio: window.devicePixelRatio,
      plugins: {
        legend: {
          display: true,
          onClick: null,
          position: 'right',
          labels: {
            font: {
              size: fontSize,
              color: fontColor,
              family: fontFamily,
            },
          },
        },
        tooltip: {
          enabled: true,
          callbacks: {
            label: function (tooltipItem) {
              return tooltipItem.label || '';
            },
          },
        },

        datalabels: {
          display: (value) => false,
        },
      },
      responsive: true,
      maintainAspectRatio: false,
      cutout: '55%',
    };
  } else {
    return {
      devicePixelRatio: window.devicePixelRatio,
      plugins: {
        legend: {
          display: true,
          onClick: null,
          position: 'bottom',
          labels: {
            font: {
              size: fontSize,
              color: fontColor,
              family: fontFamily,
            },
          },
        },
        tooltip: {
          enabled: true,
          callbacks: {
            label: function (tooltipItem) {
              return tooltipItem.label || '';
            },
          },
        },
        datalabels: {
          display: (value) => false,
        },
      },
      responsive: true,
      maintainAspectRatio: false,
      cutout: '55%',
    };
  }
}
